export const environment = {
  production: true,
  envName: "prod",
  applicationName: "Inmar.Healthcare.Recon",
  applicationApplinkFeature: "ReconUI",
  rootUrl: "https://recon.healthcare.inmar.com",
  healthcareTopBar:
    "https://auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js",
  auth0: {
    domain: "https://login.healthcare.inmar.com",
    clientId: "wCgIz8EB3LqKSD0mRbQYJpXUAJLF4Fo9",
    refreshToken: true,
    scope: "openid profile email",
  },
  authZApiRoot: {
    url: "https://api-authz.healthcare.inmar.com/v1.0",
    audience: "https://api-authz.healthcare.inmar.com",
  },
  reconApiRoot: {
    url: "https://api-recon.healthcare.inmar.com/v1.0",
    audience: "https://api-recon.healthcare.inmar.com",
  },
  rebrandStartDate: "01-13-2020",
  globalFilterRefreshInterval: 60000,
  appInsights: {
    instrumentationKey: "3c88ef53-9bec-403d-95c2-812dcf962d1e",
  },
  googleAnalytics: {
    key: "UA-84532256-6",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts